// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-listing--dtZgl a:hover{text-decoration:none}.page-listing--dtZgl .page-title--kJgBL{color:#24282f;font-weight:600}.page-listing--dtZgl .page-description--pmVyF{color:#24282f}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page-listing": "page-listing--dtZgl",
	"page-title": "page-title--kJgBL",
	"page-description": "page-description--pmVyF"
};
export default ___CSS_LOADER_EXPORT___;
